import DossierForm from 'components/dossiers/DossierForm'
import DossiersListItem from 'components/dossiers/DossiersListItem'

import EntitiesList from 'components/entities/EntitiesList';
import dotProp from "dot-prop";
import { connect } from 'react-redux'
import { getFilteredDossiers } from "selectors/dossiers";
import { Card } from 'semantic-ui-react'
import { fetchEntities } from "../../actions/entities";
import { getPersistedEntities } from "../../selectors/entities";

const mapStateToProps = (state, ownProps) => {
  const employments = getPersistedEntities('employment')(state, ownProps);
  const locations = getPersistedEntities('location')(state, ownProps);
  const employmentOptions = employments.map((emp) => {
    return { key: emp.id, value: emp.id, text: emp.name }
  })
  const locationOptions = locations.map((loc) => {
    return { key: loc.id, value: loc.id, text: loc.name }
  })

  const filters = [
    {by: 'name', getTarget: (dossier) => dossier.patient && dossier.patient.firstName + ' ' + dossier.patient.lastName },
    {by: 'location', selectOptions: locationOptions, getTarget: (dossier) => [dossier.locationId] }
  ]

  if (state.view === "admin") {
    filters.push({ by: 'employment', selectOptions: employmentOptions, getTarget: (dossier) => dossier.responsibleIds})
  }

  return {
    entities: getFilteredDossiers('list')(state, filters),
    entityName: 'dossier',
    item: DossiersListItem,
    form: DossierForm,
    listComponent: Card.Group,
    loading: state.meta.dossier.loading,
    error: state.meta.dossier.error,
    totalPages: dotProp.get(state, 'meta.dossier.keyWindows.byWindow.list.totalPages'),
    activePage: dotProp.get(state, 'meta.dossier.keyWindows.byWindow.list.page'),
    filters: filters
  };
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchExtraEntities: () => {
      dispatch(fetchEntities('locations'))
      dispatch((dispatch, getState) => {
        let activePage = dotProp.get(getState(), 'meta.dossier.keyWindows.byWindow.list.page')
        if (!activePage) dispatch(fetchEntities('dossiers', { name: 'list', page: 1, append: true }))
      })
    },
    onLoadMore: (activePage, totalPages) => {
      if(activePage < totalPages ) {
        dispatch(fetchEntities('dossiers', { name: 'list', filter: {}, page: activePage + 1, append: true }))
      }
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(EntitiesList);
